export default class Recording {
  constructor(options = {}) {
    this.recordingKey = options.recordingKey;
    this.offlineWebinarKey = options.offlineWebinarKey;
    this.title = options.title;
    this.dateUploaded = options.dateUploaded;
    this.viewCount = options.viewCount;
    this.shareCount = options.shareCount;
    this.length = options.length;
    this.avgWatchTime = options.avgWatchTime;
    this.size = options.size;
    this.source = options.source;
    this.givenName = options.givenName;
    this.surName = options.surName;
    this.email = options.email;
  }

  static get Builder() {
    class Builder {
      constructor(recordingKey) {
        this.recordingKey = recordingKey;
      }
      withOfflineWebinarKey(offlineWebinarKey) {
        this.offlineWebinarKey = offlineWebinarKey;
        return this;
      }
      withTitle(title) {
        this.title = title;
        return this;
      }
      withDateUploaded(dateUploaded) {
        this.dateUploaded = dateUploaded;
        return this;
      }
      withViewCount(viewCount) {
        this.viewCount = viewCount;
        return this;
      }
      withShareCount(shareCount) {
        this.shareCount = shareCount;
        return this;
      }
      withLength(length) {
        this.length = length;
        return this;
      }
      withAvgWatchTime(avgWatchTime) {
        this.avgWatchTime = avgWatchTime;
        return this;
      }
      withSize(size) {
        this.size = size;
        return this;
      }
      withSource(source) {
        this.source = source;
        return this;
      }
      withGivenName(givenName = '') {
        this.givenName = givenName;
        return this;
      }
      withSurName(surName = '') {
        this.surName = surName;
        return this;
      }
      withEmail(email) {
        this.email = email;
        return this;
      }
      build() {
        return new Recording(this);
      }
    }
    return Builder;
  }
}



// WEBPACK FOOTER //
// ./src/Model/Recording/Recording.js